import { render, staticRenderFns } from "./EtisArrestsImportModal.vue?vue&type=template&id=ece87296&scoped=true&"
import script from "./EtisArrestsImportModal.vue?vue&type=script&lang=ts&"
export * from "./EtisArrestsImportModal.vue?vue&type=script&lang=ts&"
import style0 from "./EtisArrestsImportModal.vue?vue&type=style&index=0&id=ece87296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ece87296",
  null
  
)

export default component.exports